module.exports = __webpack_public_path__ + "img/31.2a9ef9dd.jpg";